import { useContext, useMemo } from 'react';
import { SplitioContext, SplitioFeature } from 'components/SplitioContext';

const useMyProfileTreatment = () => {
  const { isReady: isSplitioReady, isTreatmentOn } = useContext(SplitioContext);

  return useMemo(
    () => isSplitioReady && isTreatmentOn(SplitioFeature.enableMyProfile),
    [isSplitioReady, isTreatmentOn],
  );
};

export default useMyProfileTreatment;
